import {useNavigate} from 'react-router-dom';

// react-router v6 keeps {idx} in window.history.state; idx > 0 means there's in-app navigation
// history to go back to (e.g. came from the home page by clicking an activity). idx === 0/
// undefined (direct URL access, refresh, new tab) has nowhere to go back to — falls back to
// home. Shared between the header and the closing block (same action, two entry points on the
// screen).
function useGoBackOrHome(): () => void {
  const navigate = useNavigate();

  return function goBackOrHome() {
    const hasInAppHistory = (window.history.state?.idx ?? 0) > 0;

    if (hasInAppHistory) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };
}

export default useGoBackOrHome;
